import React ,{useContext} from 'react'
import VerticalNavigation from "../components/VerticalNavigation";
import DataDescriptionContext from "../context/DataDescriptionContext";


const DataDscription = () => {
  let {responseData} = useContext(DataDescriptionContext);
  return (
    <>
    <div className="wrapper">
      <VerticalNavigation />
      <div className="container bg-light rounded main_content mx-2">
        <div className="table-fixedhead w-auto">
        <h3 className="text-center my-5">Statistical Data Description</h3>
        <table className='table-bordered px-5'>
          <thead>
            <tr>
              {responseData[2].features_name.map((item)=>(
                <th scope='col'>{item}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {responseData[2].stats_data.map((item)=>(
              <tr>
                {item.map((itm)=>(
                  <td>{itm}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        </div>
       
      </div>
    </div>
  </>
  )
}

export default DataDscription
